import { gql } from "apollo-angular";
import { LINK_FIELDS } from "./link";
import { ILLINKSnippet, INLNK } from "./template-nav-links";

export const NAVLINKS = gql`
  fragment NAVLINKS on NavigationLinks {
    navigationTitle
    templateNavLink {
        ${ILLINKSnippet}
    }
    pageLinksCollection(limit: 22){
      items{
        ... LINK_FIELDS
      }
    }
    navigation
    isMegaMenu
  }
${INLNK}
${LINK_FIELDS}`